export default function ukFormatter(input) {
    // (01x1) xxx xxxx
    const ukPattern1 = /^440?(1[0-9]{1}1)([0-9]{3})([0-9]{4})$/;

    // (01xx xx) xxxxx
    const ukPattern2 = /^440?(1[0-9]{2})([0-9]{2})([0-9]{5})$/;

    // (011x) xxx xxxx
    const ukPattern3 = /^440?(11[0-9]{1})([0-9]{3})([0-9]{4})$/;

    // (02x) xxxx xxxx
    const ukPattern4 = /^440?(2[0-9]{1})([0-9]{4})([0-9]{4})$/;

    // 03xx xxx xxxx
    const ukPattern5 = /^440?(3[0-9]{2})([0-9]{3})([0-9]{4})$/;

    // 055 xxxx xxxx
    const ukPattern6 = /^440?(55)([0-9]{4})([0-9]{4})$/;

    // 056 xxxx xxxx
    const ukPattern7 = /^440?(56)([0-9]{4})([0-9]{4})$/;

    // 070 xxxx xxxx
    const ukPattern8 = /^440?(70)([0-9]{4})([0-9]{4})$/;

    // 07624 xxxxxx
    const ukPattern9 = /^440?(7624)([0-9]{6})([0-9]{0})$/;

    // 076 xxxx xxxx
    const ukPattern10 = /^440?(76)([0-9]{4})([0-9]{4})$/;

    // 07xxx xxxxxx
    const ukPattern11 = /^440?(7[0-9]{3})([0-9]{6})([0-9]{0})$/;

    // 08xx xxx xxxx
    const ukPattern12 = /^440?(8[0-9]{2})([0-9]{3})([0-9]{4})$/;

    // 09xx xxx xxxx
    const ukPattern13 = /^440?(9[0-9]{2})([0-9]{3})([0-9]{4})$/;

    // (0169 77) xxxx
    const ukPattern14 = /^440?(169)(77)([0-9]{4})$/;

    // (01xxx) xxxxx
    const ukPattern15 = /^440?(1[0-9]{3})([0-9]{5})([0-9]{0})$/;

    // 0500 xxxxxx
    const ukPattern16 = /^440?(500)([0-9]{6})([0-9]{0})$/;

    // 0800 xxxxxx
    const ukPattern17 = /^440?(800)([0-9]{6})([0-9]{0})$/;

    const patterns = [
        ukPattern1,
        ukPattern2,
        ukPattern3,
        ukPattern4,
        ukPattern5,
        ukPattern6,
        ukPattern7,
        ukPattern8,
        ukPattern9,
        ukPattern10,
        ukPattern11,
        ukPattern12,
        ukPattern13,
        ukPattern14,
        ukPattern15,
        ukPattern16,
        ukPattern17,
    ];

    for (let i = 0; i < patterns.length; i += 1) {
        if (patterns[i].test(input)) {
            return input.replace(patterns[i], '+44 $1 $2 $3').trim();
        }
    }

    return `+${input}`;
}
